import { EVisitType } from '@giffgaff/broadband-common'

import type { CpeOrder, OrderDetail, OrderDetailActiveAppointments } from '@/api/schemas'

export const calculateStepNumber = (
  step: 'outside' | 'inside' | 'tracking',
  data?: OrderDetail,
  cpe?: CpeOrder[],
): number | undefined => {
  const steps = []

  const appointments = data?.appointments

  appointments?.forEach(appointment => {
    if (appointment.visitType === EVisitType.PRE_WORK && appointment.state === 'ACTIVE') {
      steps.push('outside')
    } else if (appointment.visitType === EVisitType.IN_HOME && appointment.state === 'ACTIVE') {
      steps.push('inside')
    }
  })

  if (cpe && cpe.length > 0) {
    steps.push('tracking')
  }

  switch (step) {
    case 'outside':
      return 1

    case 'tracking':
      if (steps.includes('outside')) return 2

      return 1

    case 'inside':
      if (steps.includes('outside') && cpe && cpe.length > 0) return 3

      if (steps.includes('outside') || (cpe && cpe.length > 0)) return 2

      return 1

    default:
      break
  }
}

export const calculateProgressState = (orderData?: OrderDetail, cpeOrderData?: CpeOrder[]) => {
  if (!orderData) return 0

  switch (orderData.stage) {
    case 'VALIDATION':
    case 'PRE_WORK':
      return 1

    case 'IN_HOME':
      if (cpeOrderData?.[cpeOrderData.length - 1]?.status === 'DELIVERED') {
        return 3 // Router has arrived
      } else {
        return 2 // Pre work done, waiting for router
      }

    case 'COMPLETION':
      return 5

    default:
      return 0
  }
}

type Appointments = {
  outside?: OrderDetailActiveAppointments[]
  inHome?: OrderDetailActiveAppointments[]
}

export const createProgressStepsList = (
  appointments?: Appointments,
  isCpeOrdersFeatureEnabled?: boolean,
  cpeOrderData?: CpeOrder[],
) => {
  const steps = ['Placed order']

  if (appointments?.outside && appointments.outside.length > 0) {
    steps.push('Outside install')
  }

  if (isCpeOrdersFeatureEnabled && cpeOrderData && cpeOrderData.length > 0) {
    steps.push('Router arrives')
  }

  if (appointments?.inHome && appointments.inHome.length > 0) {
    steps.push('Home install')
  }

  steps.push("You're live")

  return steps
}
